import React from "react";
import Layout from "./app/ashwagandha/v1/page";
import ReactDOM from "react-dom/client";

ReactDOM.createRoot(document.getElementById("react-app")!).render(
  <React.StrictMode>
    <Layout />
  </React.StrictMode>
);
